<!-- Translated: skip -->
<template>
  <Modal @close="closeModal" :wide="false" :width="'740px'" set-class="no-padding">
    <h1>Välj ålder och datum</h1>
    <p class="subtext"></p>
    <SkiSchoolFilter :start-view="true" />
    <div class="blocked center">
      <button @click="startBooking()" :disabled="!validated">Visa Skidskolor <icon name="arrow-white" :scale="1.2" /></button>
    </div>
    <div class="blocked info" v-if="SITE_CONFIG.skischool.show_site">
      <b><icon name="map" :scale="1.4" /> Samlingsplatser</b>
      <p>Samlingsplatser för skidskolan väljer man vid bokningen. Skidskolor för nybörjare utgår från både Byn och Berget. Fortsättningsgrupperna samlas vid starten av Storbacken.</p>
    </div>
  </Modal>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';
import SkiSchoolFilter from '@/components/parts/SkiSchool/SkiSchoolFilter';

export default {
  props: ['params'],
  components: {
    Modal,
    SkiSchoolFilter,
  },
  data() {
    return {
    };
  },
  mounted() {
    if (this.params.type === 'snowboard' || this.params.type === 'private') {
      const skiSchoolFilter = {
        date: null,
      };

      /*eslint-disable */
      for (var i in this.SITE_CONFIG.skischool.ages) {
        skiSchoolFilter[this.SITE_CONFIG.skischool.ages[i][1]] = false;
      }
      for (var i in this.SITE_CONFIG.skischool.levels) {
        skiSchoolFilter[i] = false;
      }

      this.$store.commit('setSkischoolFilter', skiSchoolFilter);
      /*eslint-enable */

      this.startBooking();
    }
  },
  computed: {
    validated() {
      let valid = false;

      for (var i in this.$store.state.skiSchoolFilter) { // eslint-disable-line
        if (this.$store.state.skiSchoolFilter[i]) { // eslint-disable-line
          valid = true; // eslint-disable-line
        } // eslint-disable-line
      } // eslint-disable-line

      return valid;
    },
  },
  methods: {
    ...mapMutations([
      'closeModal',
      'closeAllModals',
      'openModal',
    ]),
    startBooking() {
      this.closeAllModals();
      this.$router.push({ path: `/skidskola/oversikt?type=${this.params.type}` });
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'



button
  font-size: 13px
  margin-top: 10px
  .icon
    margin-left: 5px
    position: relative
    top -1px

.blocked
  margin-bottom space-2
  max-width:100%;
  margin-left: auto;
  margin-right: auto;

h1
  margin-bottom: 5px
  margin-top: 15px
  +max-mobile()
    font-size: 20px!important

.subtext
  text-align: center

.info
  border-radius 2px
  border-radius 2px
  background-color rgba(236, 245, 248, 0.3)
  border solid 1px light-blue-grey
  padding 15px 27px
  width: 90%
  margin: 30px auto 20px auto

  b
    font-size 11px
    font-weight bold
    color #1c1c1c
    display block
    margin-bottom 0.9em
    uppercase()
    .icon
      margin-right 3px
      position relative
      top -1px
  p
    font-size 14px
    font-weight 300
    line-height 1.3
    color #262626
    margin 0
  &.small
    padding 10px 8px
    p
      font-size 11px
      color #1c1c1c
</style>



// WEBPACK FOOTER //
// SkiSchoolPicker.vue?8462f544